import React from 'react';
import Typography from '@mui/material/Typography';

const CustomText = (props) => {
  const { color, children, component, fontSize, fontWeight, lineHeight, ...rest } = props;
  return (
    <Typography
      {...rest}
      component={component}
      color={color}
      sx={[{
        fontSize: fontSize,
        fontWeight: fontWeight,
        lineHeight: lineHeight
      }, ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx])]}>
      {children}
    </Typography>
  );
};

export default CustomText;
